module.exports = __webpack_public_path__ + "static/media/image-preview.f7d29713.svg";